import className from "classnames";
import {
  GOVGR_PANEL,
  GOVGR_PANEL__BODY,
  GOVGR_PANEL__CONFIRMATION,
  GOVGR_PANEL__TITLE,
} from "../../conf/styles/GovGrConfirmationMessage";

const GovGrConfirmationMessage = ({
  title = "Title",
  body = "",
  code = "",
}) => {
  const PanelWrapperClass = className(GOVGR_PANEL, GOVGR_PANEL__CONFIRMATION);
  const TitleWrapperClass = className(GOVGR_PANEL__TITLE);
  const BodyWrapperClass = className(GOVGR_PANEL__BODY);
  return (
    <div className={PanelWrapperClass}>
      <h1 className={TitleWrapperClass}>{title}</h1>
      <div className={BodyWrapperClass}>
        {body} <br />
        <strong>{code}</strong>
      </div>
    </div>
  );
};

export default GovGrConfirmationMessage;
